import React, { useEffect } from 'react';
import { Box, Spinner, Text, Center } from '@chakra-ui/react';

const GoogleLoginCallback = () => {
  useEffect(() => {
    // Get the token from the URL
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const error = params.get('error');
    
    if (error) {
      // If there's an error, send it to the opener window
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage({ type: 'GOOGLE_LOGIN_ERROR', error }, '*');
      }
      window.close();
      return;
    }
    
    if (token) {
      // If there's a token, send it to the opener window
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage({ type: 'GOOGLE_LOGIN_SUCCESS', token }, '*');
      }
      window.close();
    }
  }, []);

  return (
    <Center h="100vh">
      <Box textAlign="center">
        <Spinner size="xl" mb={4} />
        <Text>Completing login, please wait...</Text>
      </Box>
    </Center>
  );
};

export default GoogleLoginCallback;
